const crypto = require('crypto'); 


const Md5 = function(data) {
    // 以md5的格式创建一个哈希值
  let hash = crypto.createHash('md5');
  return hash.update(data).digest('hex').substring(8,24);
}

// //http://user.fuyouhuiyi.com/#/out-invoice?orderNum=9203242118462&orderFee=1400&invoiceNum=124102004163050355&invoiceTitle=%E5%BC%80%E5%B0%81%E5%B8%82%E5%A6%87%E5%B9%BC%E4%BF%9D%E5%81%A5%E9%99%A2&token=01cc3e8605c47fee
// console.log(Md5(`1400-9203242118462-ydtmed19`))

export { Md5 }


  
